import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

const Track = styled.div`
  flex: 1;
  height: ${(props) => props.height};
  border-radius: ${(props) => `calc(${props.height} / 2)`};
  background: #EEEEEE;
  overflow: hidden;
`;

const Fill = styled.div`
  height: 100%;
  border-radius: inherit;
  width: ${(props) => `${Math.min(props.percent, 100)}%`};
  background: ${(props) => props.color || '#77A7FF'};
`;

const ProgressBar = ({ percent, color, height }) => (
  <Track height={height}>
    <Fill percent={percent} color={color} />
  </Track>
);

ProgressBar.propTypes = {
  percent: PropTypes.number.isRequired,
  color: PropTypes.string,
  height: PropTypes.string,
};

ProgressBar.defaultProps = { color: null, height: '6px' };

export default ProgressBar;
